<form
  class="return-order-form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  novalidate
>
  <p class="return-order-intro">
    Vas a marcar como devuelto el pedido <strong>{{ orderCode }}</strong>. El motivo es
    opcional, pero si lo registras queda guardado en el pedido.
  </p>

  <div class="form-group">
    <span class="form-label">Motivo (opcional)</span>
    <div class="reason-options" role="radiogroup">
      @for (option of reasonOptions; track option) {
        <label class="reason-option">
          <input type="radio" formControlName="reasonOption" [value]="option" />
          <span>{{ option }}</span>
        </label>
      }
      <label class="reason-option">
        <input type="radio" formControlName="reasonOption" [value]="otherOptionValue" />
        <span>Otro</span>
      </label>
    </div>

    @if (form.controls.reasonOption.value) {
      <button type="button" class="btn-clear-reason" (click)="clearReason()">
        Quitar el motivo seleccionado
      </button>
    }
  </div>

  @if (isOtherSelected) {
    <div class="form-group">
      <label class="form-label" for="return-custom-reason">Detalle</label>
      <textarea
        id="return-custom-reason"
        class="form-input"
        formControlName="customReason"
        rows="3"
        placeholder="Ej: llegó con una pieza quebrada"
      ></textarea>
    </div>
  }

  <div class="form-actions">
    <button type="button" class="btn btn-outline" (click)="onCancel()">
      Volver
    </button>
    <button type="submit" class="btn btn-primary">
      Confirmar devolución
    </button>
  </div>
</form>
